export default "__VITE_ASSET__AjK4tuyC__"